import React, { ReactNode } from 'react';

function TcImage({ 
    classNameStyle = "", 
    handleClick = () => {},
    children 
}: { 
    readonly classNameStyle?: string;
    readonly handleClick?: () => void;
    readonly children: ReactNode 
}) {
    return (
        <div 
            className={`flex items-center justify-center mx-auto max-w-xl w-full h-auto overflow-hidden ${classNameStyle}`}
            onClick={handleClick}
        >
            {children}
        </div>
    )
}

export default TcImage;